module.exports = __webpack_public_path__ + "assets/img/jianxia_score-af61c0f2.png";